import { useCallback } from "react";
import type { Workspace } from "@packages/commons";
import { useDialog } from "@imminently/decisively-ui/Dialog";
import { WORKSPACE_LAYER } from "@/ui/dialogs/layers";
import { WorkspaceModal } from "../components/WorkspaceModal";
import { BrowseWorkspacesModal } from "../components/BrowseWorkspacesModal";

export const useAddWorkspaceModal = () => {
  const { pushDialog } = useDialog();
  return useCallback(() => {
    pushDialog({ layer: WORKSPACE_LAYER, options: { intent: "form" }, component: WorkspaceModal });
  }, [pushDialog]);
};

export const useEditWorkspaceModal = () => {
  const { pushDialog } = useDialog();
  return useCallback(
    (workspace: Workspace) => {
      pushDialog({
        layer: WORKSPACE_LAYER,
        options: { intent: "form" },
        component: (props) => <WorkspaceModal {...props} workspace={workspace} />,
      });
    },
    [pushDialog],
  );
};

export const useBrowseWorkspacesModal = () => {
  const { pushDialog } = useDialog();
  return useCallback(() => {
    pushDialog({ layer: WORKSPACE_LAYER, options: { intent: "cover" }, component: BrowseWorkspacesModal });
  }, [pushDialog]);
};
